module.exports = __webpack_public_path__ + "img/hc_pro_five_5.e36f8353.jpg";